
const primary_btn = "mr-5 py-3 px-10 text-sm font-medium text-center text-black rounded-3xl bg-primary-green sm:w-fit hover:cursor-pointer hover:bg-primary-blue hover:text-white";
const secondary_btn = "mr-5 py-3 px-10 text-sm font-medium text-center text-slate-600	rounded-3xl border-slate-600 border-2 hover:text-black hover:cursor-pointer";

export function FormButton ({cta, clickAction, type, style}) {

    return (
      <>
        {
          (type === "submit")
          ? <button type="submit" onClick={clickAction} className={style==="primary"?primary_btn:secondary_btn}>{cta}</button>
          : <a onClick={clickAction} className={style==="primary"?primary_btn:secondary_btn}>{cta}</a>
        }
      </>
    );
}